<template>
  <div>
  <div class="py-6 px-4 pb-24 space-y-4" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-4">
      
      <!-- Status Filter -->
      <div class="bg-white rounded-xl p-5 border border-gray-200">
        <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('NewStatusChangeStatus') }}</label>
        <div class="relative">
          <select 
            v-model="selected_status_filter"
            class="w-full px-4 py-3 border border-gray-400 rounded-xl text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 appearance-none bg-white"
          >
            <option 
              v-for="status in request_statuses"
              :key="status.ReminderStatusId"
              :value="status.ReminderStatusTitle"
            >
              {{ status.ReminderStatusTitle }}
            </option>
          </select>
          <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="request_items_filtered.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">نتیجه‌ای یافت نشد</p>
      </div>

      <!-- Reminders List -->
      <div v-else class="space-y-3">
        <div 
          v-for="item in request_items_filtered"
          :key="item.ReminderId"
          @click="goToDetail(item)"
          class="bg-white rounded-2xl border border-gray-200 p-6 cursor-pointer hover:shadow-lg hover:border-cyan-300 transition-all duration-200"
        >
          <!-- Header -->
          <div class="flex items-center gap-4 mb-4">
            <div class="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-500 to-cyan-600 flex items-center justify-center flex-shrink-0">
              <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div class="w-full">
              <p class="text-xs text-gray-500 mb-1">ایجاد کننده</p>
              <h3 class="text-base font-bold text-gray-900">{{ item.CreatorName }}</h3>
            </div>
          </div>

          <!-- Reminder Text -->
          <div class="p-4 bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-xl mb-4 border border-cyan-200">
            <p class="text-sm font-medium text-gray-900 leading-relaxed">{{ item.ReminderText }}</p>
          </div>

          <!-- Receivers -->
          <div class="flex flex-wrap gap-2 mb-4">
            <span 
              v-for="item_chip in JSON.parse(item.Receivers)"
              :key="item_chip.PersonName"
              class="px-4 py-2 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white rounded-full text-xs font-bold hover:shadow-md transition-shadow"
            >
              {{ item_chip.PersonName }}
            </span>
          </div>

          <!-- Info -->
          <div class="grid grid-cols-2 gap-3">
            <div class="p-4 bg-gray-50 rounded-xl border border-gray-200">
              <p class="text-xs text-gray-600 mb-2">تاریخ ایجاد</p>
              <p class="text-sm font-bold text-gray-900">{{ item.CreatedAt }}</p>
            </div>
            <div class="p-4 bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-xl border border-cyan-200">
              <p class="text-xs text-gray-600 mb-2">وضعیت</p>
              <p class="text-sm font-bold text-cyan-700">{{ item.StatusTitle }}</p>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <!-- Change Status Dialog -->
  <div v-if="product_info_dialog" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-90vh overflow-hidden flex flex-col">
      <!-- Header -->
      <div class="px-6 py-4 bg-gradient-to-r from-cyan-600 to-cyan-700 flex items-center justify-between flex-shrink-0">
        <h2 class="text-lg font-bold text-white w-full">{{ $t('changeStatusRequest') }}</h2>
        <button 
          @click="product_info_dialog = false"
          class="w-8 h-8 rounded-lg bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 flex items-center justify-center transition-colors"
        >
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="px-6 py-6 overflow-y-auto flex-1 space-y-4">
        <!-- Status Select -->
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('NewStatusChangeStatus') }}</label>
          <div class="relative">
            <select 
              v-model="selected_status_for_change"
              class="w-full px-4 py-3 border border-gray-400 rounded-xl text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 appearance-none bg-white"
            >
              <option 
                v-for="status in request_statuses"
                :key="status.ReminderStatusId"
                :value="status.ReminderStatusId"
                v-if="status.ReminderStatusId != 0"
              >
                {{ status.ReminderStatusTitle }}
              </option>
            </select>
            <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Summary Textarea -->
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('insertChangeStatusSummary') }}</label>
          <textarea
            v-model="change_status_summary"
            rows="3"
            class="w-full px-4 py-3 border border-gray-400 rounded-xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 resize-none"
            :placeholder="$t('insertChangeStatusSummary')"
          ></textarea>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="px-6 py-4 border-t border-gray-200 flex gap-3 flex-shrink-0">
        <button 
          @click="product_info_dialog = false"
          class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-all duration-200"
        >
          {{ $t('cancel') }}
        </button>
        <button 
          v-if="selected_status_for_change != 0"
          @click="change_tech_status()"
          class="flex-1 px-6 py-3 bg-gradient-to-r from-cyan-600 to-cyan-700 hover:from-cyan-700 hover:to-cyan-800 text-white font-medium rounded-lg transition-all duration-200"
        >
          {{ $t('ok') }}
        </button>
      </div>
    </div>
  </div>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        selected_status_filter:"انتخاب وضعیت",
        selected_status_for_change:0,
        selected_reminder:0,
        change_status_summary:'',

        active_tab: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_statuses: [],
        request_items: [],
        request_items_filtered: [],
        last_request_items: [],
        show_loading: false,
        page: 1,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      },
      selected_status_filter: function () {
        console.log("change filter",this.selected_status_filter)
        if(this.selected_status_filter=="انتخاب وضعیت"){
          this.request_items_filtered = this.request_items;
        }else{
          this.request_items_filtered = this.request_items.filter(x => x.StatusTitle==this.selected_status_filter);
        }
      }
    },
    mounted() {
      this.get_device_status();

    },

    methods: {
      get_device_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReminderStatus', send_data, {})
          .then(response => {
            self.request_statuses = [{ReminderStatusTitle:"انتخاب وضعیت",ReminderStatusId:0}]
            response.data.items.forEach(function (val) {
              self.request_statuses.push(val);
            })

            self.get_pre_requests();

          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_tech_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          Summary:this.change_status_summary,
          ReminderId:this.selected_reminder,
          StatusId:this.selected_status_for_change,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ReminderStatus', send_data, {})
          .then(response => {
            self.request_statuses = response.data.items
            self.request_items=[];
            self.page=1;
            self.product_info_dialog = false;
            self.get_pre_requests();
            bus.$emit('show_toast', [2000, response.data.msg])

          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      get_pre_requests() {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          Count: this.page,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserReminderItems', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log("items great",response.data.result.length)

              if(response.data.result.length>0){
                response.data.result = response.data.result.filter(x => x.StatusTitle!="");
                response.data.result.forEach(function (val) {
                  self.request_items.push(val);
                })
                self.page++;
                self.get_pre_requests();

              }else{
                self.request_items_filtered = self.request_items;
              }

            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item, is_parent) {
        if (this.disable_click) {
          return;
        }
        this.selected_product_info = item;
        this.product_info_dialog = true;
        this.selected_reminder = item.ReminderId
      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize() {
        var array = this.request_items.filter(x => x.selected == true);

        var finalize_items = [];
        array.forEach(function (number) {
          if (number.related_products.length == 0) {
            finalize_items.push(number);
          } else {
            number.related_products.forEach(function (number2) {
              finalize_items.push(number2);
            })
          }

        });
        console.log("array is ",finalize_items)
        localStorage.setItem('buy_orders_finalize', JSON.stringify(finalize_items));
        this.$router.push({name: 'BuyOrdersFinalize'})
      }
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }

</style>
